import React from 'react';

const hotelNav = (props) => (
    <nav className={`u-backgroundColorWhite u-boxShadowThin`}>
        <ul className={[`h-100 u-flex phone-f-wrap`, props.type === 'horizontal' ? `f-row` : `f-column`].join(' ')}>
            {props.children}
        </ul>
    </nav>
);

export default hotelNav;


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelNav/HotelNav.js